import { upperFirst } from 'lodash'

export type LinkProblem = `expired` | `cancelled` | `completed` | `invalid` | `unreachable`

export type Practice = { displayName: string; phone?: string | null }

// `open` is the only linkState with a packet; every other state maps to its own screen.
export const LINK_STATE_PROBLEM: Readonly<Record<string, LinkProblem>> = {
  not_found: `invalid`,
  expired: `expired`,
  cancelled: `cancelled`,
  completed: `completed`,
}

export function linkProblemScreen(problem: LinkProblem, practice?: Practice): { title: string; body: string } {
  const office = practice?.displayName ?? `your dental office`
  const reach = practice?.phone ? `call ${office} at ${practice.phone}` : `contact ${office}`
  switch (problem) {
    case `expired`:
      return { title: `This link has expired`, body: `${upperFirst(reach)} and they will send you a new one.` }
    case `cancelled`:
      return {
        title: `This paperwork is no longer needed`,
        body: `${upperFirst(office)} cancelled this link. If you think that is a mistake, ${reach}.`,
      }
    case `completed`:
      return {
        title: `Your paperwork is already complete`,
        body: `Thank you. ${upperFirst(office)} has your answers, so there is nothing else to do.`,
      }
    case `invalid`:
      return {
        title: `We could not find this paperwork`,
        body: `Open the full link from your text message. If it still does not work, contact your dental office.`,
      }
    case `unreachable`:
      return { title: `We could not load your paperwork`, body: `Check your connection and try again.` }
  }
}
